<template>
    <b-input
            dir="ltr"
            :class="inputClass"
            :disabled="disabled"
            v-model="model"
            :state="state"
            :size="size"
            :id="id"
            :placeholder="placeholder"
            @blur="emitEvent('blur', $event)"
            @keyup="emitEvent('keyup', $event)"
            @change="emitEvent('change', $event)"
            autocomplete="off"
    />
</template>

<script>
    import {convertNumbers2English} from '@/lib/util'
    export default {
        name: 'NumericInput',
        props: {
            value: {type: [Number, String]},
            min: {type: Number, default: null},
            max: {type: Number, default: null},
            placeholder: {type: String},
            decimal: {type: Boolean, default: true},
            decimalPlaces: {type: Number, default: 8},
            noSeprator: {type: Boolean, default: false},
            negative: Boolean,
            percent: Boolean,
            size: {type: String, default: 'md'},
            validate: String,
            state: {type: [Function, Boolean], default: null},
            prepend: String,
            append: String,
            disabled: Boolean,
            inputClass: {type: [String, Object, Array]},
            id: {type: String}
        },
        data() {
            return {
                model: this.getDisplayNumber(this.value)
            }
        },
        watch: {
            model(val, oldVal) {
                if (this.symbolEntered(val, oldVal)) return
                let number = this.getDisplayNumber(val)

                if (val !== number) {
                    this.$nextTick(() => {
                        this.model = this.getDisplayNumber(val)
                    })
                }

                if (number) {
                    number = +number.replace(/,/g, '')
                }
                this.$emit('input', number)
            },
            value(val) {
                if (this.model !== this.getDisplayNumber(val)) this.setModel(val)
            },
            decimalPlaces() {
                this.model = this.getDisplayNumber(this.model)
            }
        },
        methods: {
            regex() {
                const full = new RegExp(`[-]?[0-9]+([.][0-9]{0,${this.decimalPlaces}})?`)
                const negativeable = /[-]?[0-9]+/
                const floatable = new RegExp(`[0-9]+([.][0-9]{0,${this.decimalPlaces}})?`)
                const simple = /[0-9]+/
                const decimal = this.decimal && this.decimalPlaces > 0
                if (this.negative && decimal) {
                    return full
                }
                if (this.negative) {
                    return negativeable
                }
                if (decimal) {
                    return floatable
                }
                return simple
            },
            symbolEntered(val, oldVal) {
                val = val && val.replace(/,/g, '')
                oldVal = oldVal && oldVal.replace(/,/g, '')
                const decimal = this.decimal && this.decimalPlaces > 0
                const firstStateRegex = /^\-?\d+$/ // check current model has point or not
                const secondStateRegex = /^\-?\d+\.$/ // check the next input is point or not
                const decimalEntered = decimal && firstStateRegex.test(oldVal) && secondStateRegex.test(val)

                const negativeRegex = /^\-$/
                const negativeEntered = this.negative && negativeRegex.test(val)

                return decimalEntered || negativeEntered
            },
            emitInput(num) {
                this.$emit('input', Number(num))
            },
            getDisplayNumber(number) {
                if (number === null) {
                    return null
                }
                number = String(number)
                number = number && number.replace(/,/g, '')
                if (!number) return null

                number = convertNumbers2English(number)
                const matched = number.match(this.regex())

                if (!matched) return null
                number = matched[0]

                number = this.convertLocalString(number)
                return number
            },
            convertLocalString(val) {
                if (!val || val === null) return null
                val = +val
                if (this.noSeprator) {
                    return val.toString()
                }
                return val.toLocaleString('en-GB', {maximumFractionDigits: this.decimalPlaces})
            },
            setModel(num) {
                this.model = this.getDisplayNumber(num)
            },
            emitEvent(name, val) {
                this.$emit(name, val)
            }
        }
    }
</script>
